import { useAppStore } from '@/src/store';
import { TxComponentProps } from '@/src/types/index';
import { useEffect, useState } from 'react';

export const useModalGetADA = () => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const txComponentProps: TxComponentProps = {
        onTx: async () => {
            appStore.setIsProcessingTx(false);
            setIsOpen(false);
        },
        onCancel: async () => {
            setIsOpen(false);
        },
    };
    //--------------------------------------
    return {
        isRefreshing,
        isOpen,
        handleOpen,
        handleClose,
        txComponentProps,
    };
    //--------------------------------------
};
